'use client'

import dynamic from 'next/dynamic'

import { Banner } from '@/components/Banner/Banner'
import { BannerButtons } from '@/components/BannerButtons/BannerButtons'
import { Footer } from '@/components/Footer/Footer'
import { LPHeader } from '@/components/LPHeader/LPHeader'

import { useProposalContext } from '@/context/ProposalContext'

import { useConditionalRendering } from '@/hooks/useConditionalRendering'

const Paywall = dynamic(() =>
  import('@/components/Paywall/Paywall').then((mod) => mod.Paywall)
)

export default function Layout({ children }) {
  const { isPaywallOpen } = useProposalContext()
  const { renderedContentType } = useConditionalRendering()

  return (
    <>
      <LPHeader />

      {children}

      {renderedContentType === 'default' && (
        <Banner
          isFixed
          hasBorder
          hideTextOnMobile
          text="Central de vendas Equifax BoaVista"
        >
          <BannerButtons />
        </Banner>
      )}

      {isPaywallOpen && <Paywall />}

      <Footer />
    </>
  )
}
